import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import { HelpIcon } from 'components/atoms/HelpIcon';

const helpText = <Popover id="layer-aliases" placement="right" title="What are Layer Aliases?">
    As you create dashboards for a brand, you must select an appropriate layer alias for each dashboard. This identifies
    the type of data that exists at a given layer in the hierarchy (e.g., a dealership, city, region, product, etc.).
    This alias is used to dynamically name certain tables within the dashboards.
</Popover>;

const LayerAliasesSubHeading = () => (
    <FormSectionHeading>
        Layer Aliases
        <OverlayTrigger trigger="click" placement="right" overlay={helpText}>
            <HelpIcon />
        </OverlayTrigger>
    </FormSectionHeading>
);


export default LayerAliasesSubHeading;



// WEBPACK FOOTER //
// ./src/components/molecules/LayerAliasesSubHeading.js